import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function CheckIcon(props) {
    return (
        <SvgIcon {...props}>
            <path clipRule="evenodd" d="M22 12C22 17.5228 17.5229 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47717 6.47715 2 12 2C17.5229 2 22 6.47717 22 12ZM17.7071 9.70709C18.0976 9.31659 18.0976 8.68341 17.7071 8.29291C17.3166 7.90234 16.6834 7.90234 16.2929 8.29291L10 14.5858L7.70711 12.2929C7.31658 11.9023 6.68342 11.9023 6.29289 12.2929C5.90237 12.6834 5.90237 13.3166 6.29289 13.7071L9.29289 16.7071C9.68342 17.0977 10.3166 17.0977 10.7071 16.7071L17.7071 9.70709Z" fillRule="evenodd" />
        </SvgIcon>
    );
}

export default CheckIcon;
